import React from 'react'
import './WoodSneaker.scss'
import merinoShoe from '../../static/images/woodsneaker/merino-shoe.png'
import shoes from '../../static/images/woodsneaker/shoes.png'
import sec3Leaves from '../../static/images/woodsneaker/sec3-leaves.png'
import sec2Leaves from '../../static/images/woodsneaker/sec2-leaves.png'

import staticBgSec1Mobile from '../../static/images/woodsneaker/banner-sm.jpg'
import staticBgSec1 from '../../static/images/woodsneaker/banner.jpg'

import staticBgSec4Mobile from '../../static/images/woodsneaker/sec4-bg-sm.jpg'
import staticBgSec4 from '../../static/images/woodsneaker/sec4-bg.jpg'

const LandingPageWoodSneaker1 = ({
  sec1Heading,
  sec1Content,
  sec1ImageMobile,
  sec1Image,
  sec1Price,
  sec1Button1Text,
  sec1Button2Text,
  sec1Button1Url,
  sec1Button2Url,
  sec2Content,
  sec2Button1Text,
  sec2Button2Text,
  sec2Button1Url,
  sec2Button2Url,
  sec3Heading,
  sec3Content,
  sec3Button1Text,
  sec3Button2Text,
  sec3Button1Url,
  sec3Button2Url,
  dot1Text,
  dot2Text,
  dot3Text,
  dot4Text,
  sec4Content,
  sec4ImageMobile,
  sec4Image,
  sec4ButtonText,
  sec4ButtonUrl,
}) => {
  return (
    <div className="landingpage-woodcross">
      <style>
        {`
          .banner {
            background-image: url(${sec1ImageMobile});
          }

          @media (min-width: 568px) {
            .banner {
              background-image: url(${sec1Image});
            }
          }
        `}
      </style>

      <section className="banner">
        <div className="container">
          <article className="content clearfix">
            {sec1Heading}
            <p className="quality">{sec1Content}</p>
          </article>
        </div>
        <div className="cta">
          <div className="container px-0 px-md-3">
            <p className="d-none d-md-block h2 price pb-3">{sec1Price}</p>
            <div className="row compact btn-cont">
              <div className="col-6">
                <a
                  href={sec1Button1Url}
                  className="btn btn-dark btn-block mb-3"
                >
                  {sec1Button1Text}
                </a>
              </div>
              <div className="col-6">
                <a
                  href={sec1Button2Url}
                  className="btn btn-dark  btn-block mb-3 "
                >
                  {sec1Button2Text}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sec sec2 d-flex">
        <div className="container d-flex flex-grow-1">
          <div className="row  flex-grow-1">
            <div className=" col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 ml-auto text-center order-md-1 align-self-center ">
              <figure className="figure position-relative d-md-inline-block shoe-colors animated hide mb-5 animate fadeIn">
                <img src={shoes} alt="" className="shoe" />
              </figure>
            </div>
            <article className="content col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mr-auto order-md-2 align-self-start text-center">
              {sec2Content}
              <p className="pt-4 mb-0 text-center">
                <a
                  href={sec2Button1Url}
                  className="btn btn-dark mb-1 mr-2 btn-size-md"
                >
                  {sec2Button1Text}
                </a>{' '}
                <a
                  href={sec2Button2Url}
                  className="btn btn-dark mb-1 ml-2 btn-size-md"
                >
                  {sec2Button2Text}
                </a>
              </p>
            </article>
          </div>
        </div>
        <img src={sec2Leaves} alt="" className="leaves sec2-leaves" />
      </section>
      <section className="sec sec3 d-flex">
        <div className="container d-flex flex-grow-1">
          <div className="row  flex-grow-1">
            <article className="content col-12 col-sm-12 col-md-12 col-lg-12 col-xl-11 mx-auto align-self-center text-center">
              {sec3Heading}
              <div className="pr-xl-5">{sec3Content}</div>

              <p className="pt-4  mb-0 text-center">
                <a
                  href={sec3Button1Url}
                  className="btn btn-outline-light  mb-1 mr-2 btn-size-md"
                >
                  {sec3Button1Text}
                </a>{' '}
                <a
                  href={sec3Button2Url}
                  className="btn btn-outline-light mb-1 ml-2 btn-size-md"
                >
                  {sec3Button2Text}
                </a>
              </p>
            </article>
            <div className=" col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 ml-auto text-center align-self-center">
              <figure className="sole-features-cont  figure position-relative mb-0 d-md-inline-block">
                <p className="graphic">
                  <img src={merinoShoe} alt="" className="shoe hide animated" />
                </p>
                <ul className="sole-features animatable">
                  <li>
                    <em>
                      <span>
                        <em>{dot1Text}</em>
                      </span>
                    </em>
                  </li>
                  <li>
                    <em>
                      <span>
                        <em>{dot2Text}</em>
                      </span>
                    </em>
                  </li>
                  <li>
                    <em>
                      <span>
                        <em>{dot3Text}</em>
                      </span>
                    </em>
                  </li>
                  <li>
                    <em>
                      <span>
                        <em>{dot4Text}</em>
                      </span>
                    </em>
                  </li>
                </ul>
              </figure>
            </div>
          </div>
        </div>
        <img src={sec3Leaves} alt="" className="leaves sec3-leaves" />
      </section>

      <style>
        {`
          .sec4 {
            background-image: url(${sec4ImageMobile});
          }

          @media (min-width: 768px) {
            .sec4 {
              background-image: url(${sec4Image});
            }
          }
        `}
      </style>

      <section className="bg-white py-3 px-3 p-md-4 p-lg-5 sec4-outer">
        <div className="container-fluid sec sec4 p-4 p-sm-5 p-lg-5 d-flex">
          <div className="container px-0 d-flex flex-grow-1">
            <div className="row flex-grow-1">
              <article className="content col-12 col-sm-6 col-md-7 col-lg-7 col-xl-6 mr-auto align-self-center align-self-md-center">
                {sec4Content}
                <p className="pt-xl-4 d-flex d-sm-block mb-0">
                  <a
                    href={sec4ButtonUrl}
                    className="btn btn-outline-light mb-1 btn-size-md"
                  >
                    {sec4ButtonText}
                  </a>
                </p>
              </article>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

LandingPageWoodSneaker1.defaultProps = {
  sec1Content: 'Made of eucalyptus',
  sec1Heading: (
    <h1>
      <strong>WOOD</strong> <br /> SNEAKER
    </h1>
  ),
  sec1ImageMobile: staticBgSec1Mobile,
  sec1Image: staticBgSec1,
  sec1Price: '€ 139',
  sec1Button1Text: 'Women',
  sec1Button2Text: 'Men',
  sec1Button1Url: '#',
  sec1Button2Url: '#',
  sec2Content: (
    <>
      <h2>
        Discover the super soft shoe <br /> <strong>made of wood.</strong>
      </h2>
      <p>
        Low carbon footprint but high comfort. The natural, sustainable fabric
        for our new Wood Sneakers is made from eucalyptus fibres - extremely
        soft, cooling, breathable and biodegradable!
      </p>
    </>
  ),
  sec2Button1Text: 'Women',
  sec2Button2Text: 'Men',
  sec2Button1Url: '#',
  sec2Button2Url: '#',
  sec3Heading: (
    <h2>
      Discover the super soft shoe <br /> <strong>made of wood.</strong>
    </h2>
  ),
  sec3Content: (
    <>
      <p>
        Low carbon footprint but high comfort. The natural, sustainable fabric
        for our new Wood Sneakers is made from eucalyptus fibres - extremely
        soft, cooling, breathable and biodegradable!{' '}
      </p>
    </>
  ),
  sec3Button1Text: 'Women',
  sec3Button2Text: 'Men',
  sec3Button1Url: '#',
  sec3Button2Url: '#',
  dot1Text: 'PADDED ANTI-BLISTER HEEL',
  dot2Text: 'UNIQUE GIESSWEIN MERINO FOOTBED',
  dot3Text:
    'ADVANCED GRIP SOLE SYSTEM MADE OF EXTRA-LIGHT EVA FOAM AND BIO-RUBBER',
  dot4Text: 'PROVEN GIESSWEIN 3D STRETCH',
  sec4Content: (
    <>
      <h2>
        Unique, <br /> sustainable <br /> <strong>raw material.</strong>
      </h2>
      <p>
        Thanks to the fine layer of our unique Merino Wool 3D Stretch and the
        extra-light EVA sole, it feels like walking barefoot. The Wool Sneaker
        weighs just 160 grams.{' '}
      </p>
    </>
  ),
  sec4ImageMobile: staticBgSec4Mobile,
  sec4Image: staticBgSec4,
  sec4ButtonText: 'Know More',
  sec4ButtonUrl: '#',
}

export default LandingPageWoodSneaker1
